import React from "react";

export default function TemplateDropdown({data, fillTemplate}) {


    return (
        <div className="popup-search-two" style={{zIndex: '20'}}>
        {data.length > 0 && <div className="list-group-item splited-cu">
                    <div className='list-group-item-body'>
                        {data.slice(0, 2).map((template) => (
                            <div className='list-group-item-body-main d-flex pop-up-align mb-2' key={template.id}>
                                <div className="pop-up-content" onClick={() => fillTemplate(template)}>
                                    <div className="reduce-size-res">
                                        <span>
                                            <strong>{template.title.replace(/\b\w/g, l => l.toUpperCase())}</strong>
                                        </span>
                                    </div>
                                </div>

                                <div className="pop-up-match">
                                        <a href={`/templates/view/${template.id}`} rel="noreferrer" className="mr-2 cursor-cu">
                                            <i className="fa fa-external-link"></i>
                                        </a>
                                </div>
                            </div>
                        ))}
                    </div>
        </div>}
    </div>
    )
}
